import React, { useEffect, useState } from 'react';
import { Checkbox, Col, Descriptions, Modal, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';

const EditDeviceConfigModal = (props) => {
  const { t } = useTranslation();
  const [applyToAll, setApplyToAll] = useState(false);
  const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);

  const deviceConfig = props.deviceConfig;

  useEffect(() => {
    if (props.visible && deviceConfig?.VERSION) {
      props.loadScope(deviceConfig.VERSION);
    }
  }, [props.visible, deviceConfig?.VERSION]);

  useEffect(() => {
    if (props.visible && props.deviceConfigScope?.RESULT) {
      setApplyToAll(Boolean(props.deviceConfigScope.APPLY_TO_ALL));
      setSelectedDeviceIds(props.deviceConfigScope.DEVICE_IDS || []);
    }
  }, [props.visible, props.deviceConfigScope]);

  const handleOk = () => {
    if (!deviceConfig?.VERSION) {
      return;
    }

    props.updateScope(deviceConfig.VERSION, applyToAll, selectedDeviceIds);
    props.close();
  };

  const deviceOptions = (props.devices || []).map((device) => ({
    label: device.MAC,
    value: String(device.MAC),
  }));

  return (
    <Modal
      title={t('DeviceConfigPage.editModal.title')}
      open={props.visible}
      onOk={handleOk}
      onCancel={props.close}
      okText={t('Confirm')}
      cancelText={t('Cancel')}
    >
      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label={t('DeviceConfigPage.table.version')}>
          {deviceConfig?.VERSION || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('DeviceConfigPage.table.description')}>
          {deviceConfig?.DESCRIPTION || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('DeviceConfigPage.table.created')}>
          {deviceConfig?.CREATED_TIME || '-'}
        </Descriptions.Item>
      </Descriptions>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={24}>
          <Checkbox checked={applyToAll} onChange={(e) => setApplyToAll(e.target.checked)}>
            {t('DeviceConfigPage.editModal.applyToAll')}
          </Checkbox>
        </Col>
        <Col span={24}>
          <div style={{ marginBottom: 8 }}>
            {t('DeviceConfigPage.editModal.selectDevices')}
          </div>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            options={deviceOptions}
            value={selectedDeviceIds}
            onChange={setSelectedDeviceIds}
            disabled={applyToAll}
            placeholder={t('DeviceConfigPage.editModal.selectDevicesPlaceholder')}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default EditDeviceConfigModal;
